//#region Util Imports

import * as $ from 'jquery'

//#endregion

import { IReferenceType, IOpChangeState, IJsonSerializable } from '../util/interfaces'
import { Enums } from '../common/enums'
import { DataProvider } from '../../helpers/data-provider'


export class OpDistributorHierarchy implements IReferenceType, IOpChangeState, IJsonSerializable {
    //Properties
    public hierarchy: string    
    public idDistributor: number
    public idDistributorHierarchy: number
    public idDistributorHierarchyParent: number    
    //Properties end

    constructor(opObj: any) {
        this.fromJSON(opObj)
    }

    //IOpChangeState implementation
    public opState: Enums.OpChangeState
    //IOpChangeState implementation end
    //IReferenceType implementation
    public getReferenceType(): Enums.ReferenceType {
        return Enums.ReferenceType.IdDistributorHierarchy
    }
    public getReferenceKey(): number {
        return this.idDistributorHierarchy
    }
    public getReferenceValue(): any {
        return this
    }
    //IReferenceType implementation end

    
    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj) {

            if (compressed || (opObj && opObj.__IC && opObj.__IC == 1)) {

                this.hierarchy = opObj.H
                this.idDistributor = opObj.I
                this.idDistributorHierarchy = opObj.IH
                this.idDistributorHierarchyParent = opObj.IHP
                this.opState = opObj.O

            } else {

                this.hierarchy = opObj.HIERARCHY
                this.idDistributor = opObj.ID_DISTRIBUTOR
                this.idDistributorHierarchy = opObj.ID_DISTRIBUTOR_HIERARCHY
                this.idDistributorHierarchyParent = opObj.ID_DISTRIBUTOR_HIERARCHY_PARENT
                this.opState = opObj.OpState

            }
        }

    }

    public toJSON(compressed: boolean = false): any {

        if (compressed) {
            return {
                H: this.hierarchy,
                I: this.idDistributor,
                IH: this.idDistributorHierarchy,
                IHP: this.idDistributorHierarchyParent,
                O: this.opState,

                __IC: 1
            }
        } else {
            return {
                HIERARCHY: this.hierarchy,
                ID_DISTRIBUTOR: this.idDistributor,
                ID_DISTRIBUTOR_HIERARCHY: this.idDistributorHierarchy,
                ID_DISTRIBUTOR_HIERARCHY_PARENT: this.idDistributorHierarchyParent,
                OpState: this.opState
            }
        }
    }

    public toString() {
        return this.hierarchy
    }

    public static loadNavigationProperties(dataProvider: DataProvider, list: OpDistributorHierarchy[]): JQueryPromise<OpDistributorHierarchy[]> {
        var defered = $.Deferred<OpDistributorHierarchy[]>()

        defered.resolve(list)

        return defered.promise()
    }
}